import { render, staticRenderFns } from "./ConfirmDeleteAccountModal.vue?vue&type=template&id=5ceb777e&"
import script from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports